{
  "common": {
    "cancel": "Cancel",
    "saveChanges": "Save changes"
  },
  "createUser": {
    "title": "Add new student",
    "namePlaceholder": "Student name",
    "emailPlaceholder": "Student email",
    "accessGroupPlaceholder": "Access group",
    "noActiveGroups": "No active groups",
    "groupCourses_one": "({{count}} course)",
    "groupCourses_zero": "({{count}} courses)",
    "groupCourses_other": "({{count}} courses)",
    "password": "Password",
    "passwordMode": {
      "emailTitle": "Send link by email",
      "emailSubtitle": "The student sets their own password",
      "manualTitle": "Set password manually",
      "manualSubtitle": "You choose the student's password"
    },
    "passwordPlaceholder": "At least 8 characters",
    "submit": "Add student",
    "validation": {
      "nameMin": "Name must be at least 2 characters",
      "emailInvalid": "Invalid email",
      "passwordMin": "Password must be at least 8 characters"
    },
    "toast": {
      "createdEmailSent": "Member created — password setup email sent",
      "created": "Member created successfully!",
      "createError": "Error creating member."
    }
  },
  "roles": {
    "STUDENT": "Student",
    "INSTRUCTOR": "Instructor",
    "ADMIN": "Admin",
    "SUPER_ADMIN": "Super Admin",
    "AFFILIATE": "Affiliate"
  },
  "statuses": {
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "BLOCKED": "Blocked",
    "SUSPENDED": "Suspended",
    "PENDING_VERIFICATION": "Pending"
  },
  "userEditDialog": {
    "title": "Edit user",
    "description": "Edit the user's information and permissions",
    "personalData": "Personal data",
    "name": "Name",
    "namePlaceholder": "Full name",
    "email": "Email",
    "emailPlaceholder": "email@example.com",
    "permissions": "Permissions",
    "role": "Role",
    "rolePlaceholder": "Select the permission",
    "status": "Status",
    "statusPlaceholder": "Select the status",
    "updateError": "Error updating user",
    "validation": {
      "nameMin": "Name must be at least 3 characters",
      "emailInvalid": "Invalid email"
    }
  },
  "enrollUser": {
    "title": "Enroll user",
    "description": "Add a user to the \"{{group}}\" group",
    "successTitle": "Enrollment complete!",
    "successMessage": "{{name}} was enrolled successfully.",
    "searchLabel": "Search user *",
    "change": "Change",
    "searchPlaceholder": "Search by name, email or CPF...",
    "search": "Search",
    "noUsersFound": "No users found",
    "expirationDate": "Expiration date",
    "optional": "(optional)",
    "expirationHint": "Leave blank to use the group's settings",
    "group": "Group:",
    "productsIncluded_one": "{{count}} product included",
    "productsIncluded_zero": "{{count}} products included",
    "productsIncluded_other": "{{count}} products included",
    "enrolling": "Enrolling...",
    "enroll": "Enroll",
    "enrollError": "Error enrolling user",
    "validation": {
      "userRequired": "Select a user"
    }
  },
  "time": {
    "never": "Never",
    "justNow": "Just now",
    "minutesAgo": "{{minutes}}m ago",
    "hoursAgo": "{{hours}}h ago",
    "daysAgo": "{{days}}d ago"
  },
  "usersPage": {
    "title": "Members",
    "registeredCount_one": "{{count}} registered member",
    "registeredCount_zero": "{{count}} registered members",
    "registeredCount_other": "{{count}} registered members",
    "searchPlaceholder": "Search by name, email or CPF",
    "createStudent": "Add student",
    "filters": {
      "title": "Filters",
      "clearAll": "Clear all",
      "status": "Status",
      "allStatuses": "All",
      "accessGroup": "Access group",
      "allGroups": "All groups",
      "createdAt": "Sign-up date",
      "from": "From",
      "to": "To",
      "lastLogin": "Last access",
      "active": "Active filters:",
      "chip": {
        "status": "Status: {{value}}",
        "group": "Group: {{value}}",
        "createdAt": "Sign-up: {{from}} → {{to}}",
        "lastLogin": "Last access: {{from}} → {{to}}"
      }
    },
    "export": {
      "tooltip": "Export members as CSV",
      "button": "Export",
      "generating": "Generating CSV...",
      "empty": "No members to export",
      "success_one": "CSV generated — {{count}} member",
      "success_zero": "CSV generated — {{count}} members",
      "success_other": "CSV generated — {{count}} members",
      "error": "Error exporting",
      "fileName": "users",
      "yes": "Yes",
      "no": "No",
      "headers": {
        "id": "ID",
        "name": "Name",
        "email": "Email",
        "phone": "Phone",
        "cpf": "CPF",
        "role": "Role",
        "status": "Status",
        "emailVerified": "Email verified",
        "courses": "Courses",
        "certificates": "Certificates",
        "lastLogin": "Last login",
        "createdAt": "Signed up on"
      }
    },
    "table": {
      "member": "Member",
      "role": "Role",
      "status": "Status",
      "courses": "Courses",
      "certificates": "Certificates",
      "lastLogin": "Last access",
      "actions": "Actions"
    },
    "actions": {
      "openMenu": "Open menu",
      "edit": "Edit member",
      "generateDeepLink": "Generate deep link",
      "sendPasswordReset": "Send password setup email",
      "deactivate": "Deactivate member",
      "activate": "Activate member"
    },
    "toast": {
      "activated": "Member activated",
      "deactivated": "Member deactivated",
      "statusError": "Error changing status",
      "passwordResetSent": "Password setup email sent to {{email}}",
      "emailError": "Error sending email",
      "deepLinkError": "Error generating deep link"
    },
    "pagination": {
      "showing": "Showing <bold>{{from}}</bold> – <bold>{{to}}</bold> of <bold>{{total}}</bold> members",
      "previous": "Previous",
      "next": "Next"
    },
    "empty": {
      "title": "No members found",
      "filtered": "Try another search or clear the filters",
      "none": "No members registered"
    },
    "deepLink": {
      "title": "Deep Link",
      "accessLinkFor": "Access link for <strong>{{name}}</strong>",
      "copiedToast": "Link copied!",
      "copied": "Copied!",
      "copy": "Copy link",
      "importantInfo": "Important information:",
      "valid24h": "Valid for 24 hours",
      "singleUse": "Single use - it will be invalidated after the first access",
      "autoAuth": "The member will be signed in automatically"
    }
  },
  "userEdit": {
    "backToMembers": "Back to Members",
    "pendingChanges": "Unsaved changes",
    "avatar": {
      "invalidImage": "Select a valid image",
      "tooLarge": "The image must be at most 5MB",
      "updated": "Photo updated — click Save to keep it",
      "uploadError": "Error uploading image",
      "uploading": "Uploading…",
      "change": "Change photo"
    },
    "toast": {
      "updated": "Member updated successfully",
      "updateError": "Error updating member"
    },
    "validation": {
      "nameMin": "Name must be at least 2 characters",
      "urlInvalid": "Invalid URL",
      "phoneInvalid": "Invalid phone number",
      "cpfDigits": "CPF must have 11 digits"
    },
    "summary": {
      "memberId": "Member ID",
      "courses": "Courses",
      "lessons": "Lessons",
      "certificatesShort": "Certs.",
      "totalXp": "Total XP",
      "createdAt": "Signed up on",
      "lastLogin": "Last login"
    },
    "tabs": {
      "overview": "Overview",
      "overviewShort": "General",
      "profile": "Personal data",
      "profileShort": "Profile",
      "progress": "Progress",
      "gamification": "Gamification",
      "gamificationShort": "XP",
      "surveys": "Surveys",
      "surveysShort": "Surv.",
      "certificates": "Certificates",
      "certificatesShort": "Cert."
    },
    "overview": {
      "personalData": "Personal data",
      "fullName": "Full name",
      "email": "Email",
      "phone": "Phone",
      "cpf": "CPF",
      "birthDate": "Date of birth",
      "permissionsAndStatus": "Permissions and status",
      "role": "Role",
      "status": "Status",
      "language": "Language"
    },
    "groups": {
      "title": "Access groups",
      "selectedOfTotal": "<bold>{{selected}}</bold> of <bold>{{total}}</bold>",
      "pending": "Pending",
      "hint": "Select groups to enroll the member in all of the group's courses.",
      "noActiveGroups": "No active access groups",
      "searchPlaceholder": "Search groups...",
      "selectedCount_one": "{{count}} selected",
      "selectedCount_zero": "{{count}} selected",
      "selectedCount_other": "{{count}} selected",
      "clear": "Clear",
      "noMatch": "No groups match the filter",
      "showing": "Showing {{shown}} of {{total}} groups",
      "current": "Current"
    },
    "access": {
      "title": "Terms and access",
      "terms": "Terms of use",
      "acceptance": "Acceptance",
      "accepted": "Accepted",
      "pending": "Pending",
      "acceptanceDate": "Acceptance date",
      "firstAccess": "First access",
      "date": "Date",
      "neverAccessed": "Never accessed",
      "ip": "IP",
      "location": "Location",
      "userAgent": "Browser / Device",
      "lastAccess": "Last access",
      "termsHistory": "Terms acceptance history",
      "version": "Version",
      "versionValue": "v{{version}}",
      "locationFull": "Location"
    },
    "surveys": {
      "emptyTitle": "No surveys answered",
      "emptyDescription": "This member hasn't answered any surveys yet",
      "answered": "Answered",
      "answers": "Answers",
      "latest": "Latest",
      "surveyFallback": "Survey",
      "answeredAt": "Answered on {{date}}",
      "completed": "Completed",
      "questionFallback": "Question"
    },
    "profile": {
      "notProvided": "Not provided",
      "personalData": "Personal data",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "cpf": "CPF",
      "birthDate": "Date of birth",
      "gender": "Gender",
      "educationAndExperience": "Education and experience",
      "occupation": "Occupation",
      "education": "Education level",
      "experience": "Experience",
      "bio": "Bio",
      "interestsAndSkills": "Interests and skills",
      "interests": "Areas of interest",
      "hobbies": "Hobbies",
      "skills": "Skills",
      "address": "Address",
      "country": "Country",
      "zipCode": "ZIP code",
      "state": "State",
      "city": "City",
      "neighborhood": "Neighborhood",
      "street": "Street",
      "number": "Number",
      "complement": "Address line 2",
      "customFields": "Custom fields",
      "socialNetworks": "Social networks",
      "website": "Website"
    },
    "progress": {
      "summary": "Learning summary",
      "enrollments": "Enrollments",
      "lessonsStarted": "Lessons started",
      "lessonsCompleted": "Lessons completed",
      "certificates": "Certificates",
      "completionRate": "Completion rate",
      "enrolledCourses": "Enrolled courses ({{count}})",
      "noEnrollments": "No enrollments recorded",
      "enrolledAt": "Enrolled on {{date}}",
      "courseCompletedAt": "Completed on {{date}}",
      "recentLessons": "Recent lessons ({{count}})",
      "noActivity": "No activity recorded",
      "lessonCompletedAt": "Completed on {{date}}",
      "lastUpdatedAt": "Last updated on {{date}}"
    },
    "gamification": {
      "totalXp": "Total XP",
      "level": "Level {{level}}",
      "achievements": "Achievements",
      "available": "Available",
      "completeness": "Completion",
      "achievementProgress": "Achievement progress",
      "unlocked": "Unlocked achievements ({{count}})",
      "noneUnlocked": "No achievements unlocked yet",
      "locked": "To unlock ({{count}})",
      "points": "{{points}} XP"
    }
  }
}
